import * as R from 'ramda';

const PATH_SEGMENTS = {
  module: { legacy: 1, current: 0 },
  submodule: { legacy: 2, current: 1 },
  unit: { legacy: 3, current: 2 },
};

const getPathSegment = (quiz, segment) => {
  const { legacy, current } = PATH_SEGMENTS[segment];
  const path = R.propOr([], 'path', quiz);

  if (R.path([legacy, 'display_name'], path) || R.path([legacy, 'id'], path)) {
    return R.nth(legacy, path);
  }

  return R.nth(current, path);
};

export const getQuizModuleName = (quiz) =>
  R.propOr('Unknown module', 'display_name', getPathSegment(quiz, 'module'));

export const getQuizSubmoduleName = (quiz) =>
  R.propOr('Unknown submodule', 'display_name', getPathSegment(quiz, 'submodule'));

export const getQuizUnitName = (quiz) =>
  R.propOr('Unknown unit', 'display_name', getPathSegment(quiz, 'unit'));

export const getQuizUnitId = (quiz) =>
  R.prop('id', getPathSegment(quiz, 'unit'));
